import { Link } from 'react-router-dom';
import type { Team } from '@localagent/sdk';

export function WorkspaceTeamsList({ teams }: { teams: Team[] }) {
  if (teams.length === 0) return null;
  return (
    <section data-testid="workspace-teams" className="rounded-lg bg-card p-4">
      <h3 className="text-body font-medium">Teams using this workspace</h3>
      <ul className="mt-2 space-y-1">
        {teams.map((team) => (
          <li key={team.id}>
            <Link
              to={`/work/teams/${team.id}`}
              data-testid={`workspace-team-${team.id}`}
              className="text-body text-primary hover:underline"
            >
              {team.name}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
